<template>
  <div class="template messageManagement">
    <el-form :inline="true" class="div_form">
      <el-form-item :label="$t('im.common.accountNum')">
        <el-input v-model="visitorsID" :placeholder="$t('im.common.placeholderAccountNum')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.common.visitorsName')">
        <el-input v-model="visitorsName" :placeholder="$t('im.common.placeholderVisitorsName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.common.visitorsIp')">
        <el-input v-model="visitorsIp" :placeholder="$t('im.common.placeholderVisitorsIp')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.common.visitorsAddress')" class="div_item">
        <el-select v-model="province" :placeholder="$t('im.common.placeholderProvince')" @change="selectProvince">
          <el-option
            v-for="item in provinceData"
            :key="item.name"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
        <el-select v-model="city" :placeholder="$t('im.common.placeholderCity')">
          <el-option
            v-for="item in cityData"
            :key="item.name"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.status')">
        <el-select v-model="answerStatus" :placeholder="$t('im.common.placeholderStatus')">
          <el-option
            v-for="item in answerStatusData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.replayOperator')">
        <el-select v-model="chatName" :placeholder="$t('im.common.placeholderReplayOperator')">
          <el-option
            v-for="item in chatData"
            :key="item.id"
            :label="item.displayName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.startTime')">
        <el-date-picker
          v-model="startTime"
          type="datetime"
          :placeholder="$t('im.common.placeholderStartTime')">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('im.common.endTime')">
        <el-date-picker
          v-model="endTime"
          type="datetime"
          :placeholder="$t('im.common.placeholderEndTime')">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('im.common.bizCodeName')">
        <el-select v-model="businessGroupCode" :placeholder="$t('im.common.placeholderBizCodeName')">
          <el-option
            v-for="item in businessGroupData"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="div_btn">
        <el-button type="primary" size="small" @click="searchMessageList">{{$t('im.bt.find')}}</el-button>
        <el-button type="primary" size="small" @click="exportData">{{$t('im.bt.export')}}</el-button>
        <el-button size="small" @click="resetRule">{{$t('im.bt.reset')}}</el-button>
      </el-form-item>
    </el-form>
    <el-table border
              v-if="messageData"
              :data="messageData"
              :row-class-name="tableRowClassName"
              tooltip-effect="dark"
              style="width: 100%">
      <el-table-column :label="$t('im.common.detail')" width="55px">
        <template slot-scope="scope">
          <el-button :class="scope.row.viewTag==1?'detail hasRead':'detail'" type="text" @click="goMessagePop(scope.row)">{{$t('im.common.detail')}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :prop="item.id" :label="item.name" v-for="item in messageNav" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <div class="block flexEnd" v-if="totalNum>0">
      <el-pagination
        background
        @size-change="pageSizeChange"
        @current-change="currentChange"
        :current-page="currentPage"
        :page-sizes="[8,16, 24, 32, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </div>
    <!--留言详情-->
    <el-dialog :title="$t('im.messageManagement.messageDetailTitle')" :visible.sync="isToMessagePop">
      <div class="padding">
        <div class="assessInfo">
          <ul>
            <li><span>{{$t('im.common.name')}}</span><p>{{evaluatedInfo.name}}</p></li>
            <li><span>{{$t('im.common.phone')}}</span><p>{{evaluatedInfo.phone}}</p></li>
            <li><span>{{$t('im.common.tel')}}</span><p>{{evaluatedInfo.cellPhone}}</p></li>
            <li><span>{{$t('im.common.email')}}</span><p>{{evaluatedInfo.email}}</p></li>
            <li><span>{{$t('im.common.weChat')}}</span><p>{{evaluatedInfo.wechat}}</p></li>
            <li><span>{{$t('im.common.qq')}}</span><p>{{evaluatedInfo.qq}}</p></li>
            <li><span>{{$t('im.common.zalo')}}</span><p>{{evaluatedInfo.zalo}}</p></li>
            <li><span>{{$t('im.common.facebook')}}</span><p>{{evaluatedInfo.facebook}}</p></li>
            <li><span>{{$t('im.common.whatsApp')}}</span><p>{{evaluatedInfo.whatsapp}}</p></li>
            <li><span>{{$t('im.common.bizCodeName')}}</span><p>{{evaluatedInfo.bizCodeName}}</p></li>
            <li class="width"><span>{{$t('im.messageManagement.messageCon')}}</span><p>{{evaluatedInfo.leaveMessage}}</p></li>
            <li class="width">
              <span>{{$t('im.messageManagement.replyCon')}}</span>
              <el-input type="textarea" v-model="evaluatedInfo.answerContent" :placeholder="$t('im.messageManagement.placeholderReply')" oninput="value=value.replace(/\s/g, '')" maxlength="100" show-word-limit></el-input>
            </li>
            <li class="width">
              <span>{{$t('im.common.remark')}}</span>
              <el-input type="textarea" v-model="evaluatedInfo.remark" :placeholder="$t('im.common.placeholderRemark')" oninput="value=value.replace(/\s/g, '')" maxlength="100" show-word-limit></el-input>
            </li>
          </ul>
        </div>
      </div>
      <div class="flexCenter" v-if="evaluatedInfo.operator==userInfo.id||evaluatedInfo.answerStatus!=1">
        <el-button type="primary" size="small" @click="saveMessageInfo">{{$t('im.bt.save')}}</el-button>
        <el-button size="small" @click="isToMessagePop=false">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  require('@/styles/IM/template.css');
  import apiChatSystem from "@/api/im/chatSystem"
  import { localRead} from '@/utils/tools'
  import {TextToCode} from 'element-china-area-data'
  import download from '@/utils/download'
  import Util from '@/utils/IM/tradeDataUtil'
  export default {
    name: 'messageManagement',
    data(){
      return{
        util: Util,
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),
        messageNav: [
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.common.accountNum'), id: 'account' },
          { name: window.$t('im.common.visitorsName'), id: 'name' },
          { name: window.$t('im.common.visitorsIp'), id: 'userIp' },
          { name: window.$t('im.common.visitorsAddress'), id: 'userAddress' },
          { name: window.$t('im.common.massageTime'), id: 'createDate' },
          { name: window.$t('im.common.status'), id: 'answerStatusName' },
          { name: window.$t('im.common.replayTime'), id: 'updateDate' },
          { name: window.$t('im.common.massageType'), id: 'userTypeName' },
          { name: window.$t('im.common.replayOperator'), id: 'operatorName' },
        ],//留言列表标题
        messageData: [],//留言列表
        currentPage:1,//当前页数
        pageSize: 8, //当前页条数数
        totalNum: 0,  //当前资源条数
        userTypeData:[
          {name:window.$t('im.common.traveler'),id:0},
          {name:window.$t('im.common.demo'),id:1},
          {name:window.$t('im.common.inactivated'),id:2},
          {name:window.$t('im.common.activated'),id:3},
        ],//用户类型
        visitorsID:"",//访客ID
        visitorsName:'',//访客姓名
        visitorsIp:'',//访客IP
        provinceData:[],//省份数据
        province:'',
        cityData:[],//城市数据
        city:"",
        answerStatusData:[
          {name:window.$t('im.messageManagement.replyNo'),id:0},
          {name:window.$t('im.messageManagement.replyYes'),id:1},
        ],//状态
        answerStatus:'',
        chatData: [],//客服列表
        chatName: '',
        startTime: '',//开始时间
        endTime:'',//结束时间
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCode: '',  //业务编码Code
        bizCodes:[],//业务编码Code组
        isToMessagePop: false,//是否展示留言详情列表
        evaluatedInfo: '',//留言个人信息
      }
    },
    methods:{
      /*初始化业务组*/
      initBusinessGroup() {
        let data = []
        if (this.businessGroupData.length > 0) {
          for (const i in this.businessGroupData) {
            data.push(this.businessGroupData[i].code)
          }
          this.bizCodes = data
        }
      },
      /*刷选业务列表*/
      brushBusinessGroup(obj) {
        for (const j in this.businessGroupData) {
          if (this.businessGroupData[j].code == obj.bizCode) {
            obj.bizCodeName = this.businessGroupData[j].name
          }
        }
        return obj
      },
      /*刷选用户类型*/
      brushUserType(obj) {
        for (const j in this.userTypeData) {
          if (this.userTypeData[j].id == obj.userType) {
            obj.userTypeName = this.userTypeData[j].name
          }
        }
        return obj
      },
      /*刷选用户类型*/
      brushAnswerStatus(obj) {
        for (const j in this.answerStatusData) {
          if (this.answerStatusData[j].id == obj.answerStatus) {
            obj.answerStatusName = this.answerStatusData[j].name
          }
        }
        return obj
      },
      /*获取数据*/
      getMessageList(data) {
        apiChatSystem.queryBizLeaveMessageListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result.list) {
              let newData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in newData) {
                if (newData[i].userType == 0||Util.isEmpty(newData[i].userType)) {
                  newData[i].account = ''
                }
                this.brushBusinessGroup(newData[i])
                this.brushUserType(newData[i])
                this.brushAnswerStatus(newData[i])
              }
              this.messageData = newData
            } else {
              this.messageData = []
            }
            this.totalNum = res.result.total
          }
        })
      },
      /*初始化留言列表*/
      initMessageList(){
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          bizCodes: this.bizCodes,
          viewName: this.userInfo.userName
        }
        this.getMessageList(data)
      },
      /*切换留言列表分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          account: this.visitorsID,
          name: this.visitorsName,
          userIp:this.visitorsIp,
          province: this.province,
          city: this.city,
          answerStatus:this.answerStatus,
          operatorName:this.chatName,
          queryStartTime : Util.isNotEmpty(this.startTime)?new Date(this.startTime).format("Y-MM-dd hh:mm:ss"):"",
          queryEndTime: Util.isNotEmpty(this.endTime)?new Date(this.endTime).format("Y-MM-dd hh:mm:ss"):"",
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          pageSize: val,
          pageNum: this.currentPage,
          bizCodes: this.bizCodes,
          viewName: this.userInfo.userName
        }
        this.getMessageList(data)
      },
      /*切换留言列表当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          account: this.visitorsID,
          name: this.visitorsName,
          userIp:this.visitorsIp,
          province: this.province,
          city: this.city,
          answerStatus:this.answerStatus,
          operatorName:this.chatName,
          queryStartTime : Util.isNotEmpty(this.startTime)?new Date(this.startTime).format("Y-MM-dd hh:mm:ss"):"",
          queryEndTime: Util.isNotEmpty(this.endTime)?new Date(this.endTime).format("Y-MM-dd hh:mm:ss"):"",
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          pageNum: val,
          pageSize: this.pageSize,
          bizCodes: this.bizCodes,
          viewName: this.userInfo.userName
        }
        this.getMessageList(data)
      },
      /*刷选留言列表*/
      searchMessageList() {
        let data = {
          account: this.visitorsID,
          name: this.visitorsName,
          userIp:this.visitorsIp,
          province: this.province,
          city: this.city,
          answerStatus:this.answerStatus,
          operator:this.chatName,
          queryStartTime : Util.isNotEmpty(this.startTime)?new Date(this.startTime).format("Y-MM-dd hh:mm:ss"):"",
          queryEndTime: Util.isNotEmpty(this.endTime)?new Date(this.endTime).format("Y-MM-dd hh:mm:ss"):"",
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          pageNum: 1,
          pageSize: this.pageSize,
          bizCodes: this.bizCodes,
          viewName: this.userInfo.userName
        }
        this.getMessageList(data)
      },
      /*导出数据*/
      exportData() {
        let data = {
          account: this.visitorsID,
          name: this.visitorsName,
          userIp: this.visitorsIp,
          province: this.province,
          city: this.city,
          answerStatus: this.answerStatus,
          operator: this.chatName,
          queryStartTime: Util.isNotEmpty(this.startTime) ? new Date(this.startTime).format('Y-MM-dd hh:mm:ss') : '',
          queryEndTime: Util.isNotEmpty(this.endTime) ? new Date(this.endTime).format('Y-MM-dd hh:mm:ss') : '',
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          pageNum: 1,
          pageSize: this.pageSize,
          bizCodes: this.bizCodes
        }
        download.exportExcel(apiChatSystem.exportLeaveMessage(), data, window.$t('im.messageManagement.messageExport'))
      },
      /*重置*/
      resetRule() {
        this.visitorsID = ''
        this.visitorsName = ''
        this.visitorsIp = ''
        this.province = ''
        this.city = ''
        this.answerStatus = ''
        this.chatName = ''
        this.startTime = ''
        this.endTime = ''
        this.businessGroupCode = ''
        this.cityData = []
        this.currentPage = 0
        this.initMessageList()
      },
      /*初始化地区*/
      initArea() {
        for (const i in TextToCode) {
          this.provinceData.push({ name: i, code: TextToCode[i].code })
        }
      },
      /*选择省份*/
      selectProvince(val) {
        this.city = ''
        let data = JSON.parse(JSON.stringify(TextToCode[val]))
        let newData = [], name = ''
        delete data['全部']
        delete data.code
        for (const i in data) {
          if (i == '市辖区') {
            name = val
          } else {
            name = i
          }
          newData.push({ name: name, code: data[i].code })
        }
        this.cityData = newData
      },
      /*初始化客服列表*/
      initThisList() {
        let data = { companyId: this.userInfo.companyId }
        apiChatSystem.getThisList(data).then(res => {
          if (res.code == 0) {
            if (res.result && res.result.length > 0) {
              this.chatData = res.result
            }
          }
        })
      },
      tableRowClassName(data) {
        if (data.row.viewTag == 1) {
          return 'hasRead'
        }
        return '';
      },
      /*留言详情*/
      goMessagePop(obj) {
        this.isToMessagePop = true
        this.getViewTag(obj.id)
        this.brushBusinessGroup(obj)
        this.evaluatedInfo = obj
      },
      /*获取是否阅读标记*/
      getViewTag(id){
        let data = {
          username: this.userInfo.userName,
          messageId: id
        }
        apiChatSystem.addMessageViewTag(data).then(res => {
          if (res.code != 0 || res.result != true) {
            this.$message.error(res.message)
          }
        })
      },
      /*保存留言信息*/
      saveMessageInfo() {
        if (Util.isNotEmpty(this.evaluatedInfo.answerContent)) {
          let data = {
            id: this.evaluatedInfo.id,
            answerContent: this.evaluatedInfo.answerContent,
            remark: this.evaluatedInfo.remark,
            operatorName: this.userInfo.displayName,
            operator: this.userInfo.id,
            answerStatus: 1
          }
          apiChatSystem.updateBizLeaveMessage(data).then(res => {
            if (res.code == 0 && res.result == true) {
              this.$message.success(window.$t('im.messageManagement.saveMessageSuc'))
              this.isToMessagePop = false
              this.initMessageList()
            } else {
              this.$message.error(window.$t('im.messageManagement.saveMessageFail'))
            }
          })
        } else {
          this.$message.error(window.$t('im.messageManagement.isNull'))
        }
      }
    },
    mounted() {
      this.initBusinessGroup();
      this.initArea()
      this.initThisList()
      this.initMessageList()
    }
  }
</script>
<style>
  .messageManagement .div_form .el-form-item{width: 23%}
  .messageManagement .div_form .el-form-item__content{width: 69%}
  .messageManagement .div_form .el-date-editor,
  .messageManagement .div_form .el-select{width: 100%}
  .messageManagement .div_form .div_item .el-form-item__content .el-select{width: 47.5%;float: left;margin-right: 2.5%}
  .messageManagement .div_form .div_item .el-form-item__content .el-select:last-child{margin-left: 2.5%;margin-right:0}
  .messageManagement .div_form .div_btn .el-form-item__content{width: 100%;}
  .messageManagement .detail.hasRead.el-button--text,
  .messageManagement .el-table .hasRead .cell.el-tooltip{color: #999}
  .messageManagement .el-table .hasRead {
    background: #fafafa;
  }
  .messageManagement .assessInfo li{width: 50%}
  .messageManagement .assessInfo li:nth-child(3n) p,
  .messageManagement .assessInfo li.width p,
  .messageManagement .assessInfo li .el-input,
  .messageManagement .assessInfo li .el-textarea{border-right: 1px solid #DCDFE6;}
  .messageManagement .assessInfo li .el-textarea{width: 86.3%}
  .messageManagement .assessInfo li:nth-child(2n) p,
  .messageManagement .assessInfo li.width p,
  .messageManagement .assessInfo li .el-input,
  .messageManagement .assessInfo li .el-textarea{border-right: none}
  .messageManagement .assessInfo li.width span{width: 20%}
  .messageManagement .assessInfo li.width p,
  .messageManagement .assessInfo li.width .el-input,
  .messageManagement .assessInfo li .el-textarea{width: 80%}
  .messageManagement .assessInfo li.width p{text-align: left}
  .messageManagement .assessInfo li.width .el-textarea .el-input__count{width: auto;height: auto}
</style>
